import React from 'react';
import styled from '@emotion/styled';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';

const ImprintContainer = styled.div`
  background-color: #f4f7fb;
  border-radius: 8px;
  color: #333;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const Paragraph = styled.p`
  margin: 5px 0;
  font-size: 14px;
  line-height: 1.2;
`;

const BoldParagraph = styled(Paragraph)`
  font-weight: bold;
`;

const Imprint: React.FC = () => {
  const { t } = useI18n();

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.imprint_title)} />
      <ImprintContainer>
        <SectionTitle>{t(TranslationKeys.imprint_publisher)}</SectionTitle>
        <BoldParagraph>
          {t(TranslationKeys.imprint_address_line_1)}
        </BoldParagraph>
        <BoldParagraph>
          {t(TranslationKeys.imprint_address_line_2)}
        </BoldParagraph>
        <BoldParagraph>
          {t(TranslationKeys.imprint_address_line_3)}
        </BoldParagraph>
        <br />
        <Paragraph>{t(TranslationKeys.imprint_telephone)}</Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_email)}</Paragraph>
        <br />
        <Paragraph>{t(TranslationKeys.imprint_company_register)}</Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_local_court)}</Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_company_headquarters)}</Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_vat_number)}</Paragraph>

        <SectionTitle>{t(TranslationKeys.imprint_chairman)}</SectionTitle>
        <Paragraph>{t(TranslationKeys.imprint_chairman_name)}</Paragraph>

        <SectionTitle>
          {t(TranslationKeys.imprint_executive_board)}
        </SectionTitle>
        <Paragraph>
          {t(TranslationKeys.imprint_executive_board_chairman)}
        </Paragraph>
        <Paragraph>
          {t(TranslationKeys.imprint_executive_board_member1)}
        </Paragraph>
        <Paragraph>
          {t(TranslationKeys.imprint_executive_board_member2)}
        </Paragraph>

        <SectionTitle>
          {t(TranslationKeys.imprint_editorial_office)}
        </SectionTitle>
        <Paragraph>{t(TranslationKeys.imprint_company)}</Paragraph>

        <SectionTitle>
          {t(TranslationKeys.imprint_corporate_communications)}
        </SectionTitle>
        <Paragraph>{t(TranslationKeys.imprint_company)}</Paragraph>
        <Paragraph>
          {t(TranslationKeys.imprint_corporate_communications_text)}
        </Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_kuchenstrasse_9)}</Paragraph>
        <Paragraph>{t(TranslationKeys.imprint_braunschweig)}</Paragraph>
        <br />
        <Paragraph>
          {t(TranslationKeys.imprint_information_disclaimer)}
        </Paragraph>
        <br />
        <Paragraph>{t(TranslationKeys.imprint_dispute_resolution)}</Paragraph>
      </ImprintContainer>
    </MainContainer>
  );
};

export default Imprint;
